import React from 'react';
import './Company.css';
import Accomplishment from '../common/Accomplishment/Accomplishment';
import TitleAndDate from '../common/TitleAndDate/TitleAndDate';
import TechLine from '../common/TechLine/TechLine';


const Company = ({ name, dates, title, technologies, groups, bullets }) => {
  return (
    <div className="company">
      <TitleAndDate text={name} dates={dates} />
      <p className="company-job-title">{title}</p>
      { technologies && <TechLine text={technologies} /> }
      { groups ? (
        groups.map((group) => (
          <div key={group.heading} className="company-group">
            <h4 className="company-group-heading">{group.heading}</h4>
            <Accomplishment data={group.bullets} />
          </div>
        ))
      ) : (
        <Accomplishment data={bullets} />
      )}
    </div>
  )
}

export default Company;
